import * as types from "./mutation-types";
import { file_empty, file_estrutura_empty } from "./getters";
import _ from "lodash";

export default {
  [types.SET_FILES](state, payload) {
    state.files = payload;
  },
  [types.PENNDING_FILES](state, payload) {
    state.pedding_files = payload;
  },
  [types.SET_FILE](state, payload) {
    payload = _.merge(file_empty(), payload);
    state.file = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  },
  [types.SET_ESTRUTURA](state, payload) {
    state.estrutura = payload;
  },
  [types.ADD_ESTRUTURA](state, payload) {
    payload = _.merge(file_estrutura_empty(), payload);
    state.estrutura.push(payload);
  },
  [types.SET_LOADING](state, payload) {
    state.loading = payload;
  },
};
